<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-sport"
  [activeStep]="0"
  [sectionTitle]="'activity_creation.sport.section.title' | translate"
  [sectionDescription]="
    'activity_creation.sport.section.description' | translate
  "
  [error$]="error$"
  [formGroup]="formGroup"
  [previousUrl]="previousUrl"
  [previousNavigationExtras]="previousNavigationExtras"
  [previousQueryParametersHandling]="previousQueryParametersHandling"
  (formSubmit)="submit($event)"
>
  <app-form-control [errorMessages]="errorMessages('sport')">
    <p class="sr-only" custom-label>
      {{ 'a11y.activity_creation.sport.form.sport.label' | translate }}
    </p>

    <app-form-autocomplete
      #controlChild
      formControlName="sport"
      [placeholder]="
        'activity_creation.sport.form.sport.placeholder' | translate
      "
      [autoFilter]="true"
      [suggestions]="autocompleteSuggestions"
      [triggerText]="activitySportName"
      [required]="true"
    ></app-form-autocomplete>
  </app-form-control>
</app-organizer-shared-form-wrapper>
